module.exports = __webpack_public_path__ + "static/media/bellabyte-logo-branding-01-768x591.678c21ee.jpg";